import { PinkRectangle } from "../styles/Images";
import { EventsWrapper } from "../styles/Layouts";
import { StripeMessage } from "../styles/Typography";
import emailjs from "@emailjs/browser";

const Success = () => {
  const reservation = JSON.parse(localStorage.getItem("pendingReservation"));

  if (reservation) {
    emailjs.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, reservation, process.env.REACT_APP_PUBLIC_KEY).then(
      () => {
        console.log("Success!");
        console.log("Reservation submitted for: ", reservation);
        localStorage.removeItem("pendingReservation");
        console.log("Confirmation email sent.");
      },
      (error) => {
        console.log("Failed...", error.text);
      },
    );
  }

  return (
    <EventsWrapper>
      <PinkRectangle>
        <StripeMessage>Thank you for your purchase. See you soon!</StripeMessage>
      </PinkRectangle>
    </EventsWrapper>
  );
};

export default Success;
